



























































































































import Vue from "vue";
import axios, { AxiosPromise } from "axios";
import Multiselect from "vue-multiselect";
import get from "lodash-es/get";
import debounce from "lodash-es/debounce";
import isEmpty from "lodash-es/isEmpty";
import find from "lodash-es/find";
import orderBy from "lodash-es/orderBy";
import moment from "moment";
import Datepicker from "../../components/Datepicker.vue";
import DateRangePicker from "../../components/DateRangePicker.vue";
import {
  AutobedrijfViewModel,
  DropdownItemModel,
  DropdownItemStringViewModel,
  FixedPeriodType,
  FilterValuesPeriod,
} from "../../TypeScriptModels";

export interface VestigingViewModel {
  Id: string;
  Omschrijving: string;
  ZoneId: number;
  AutobedrijfId: string;
}

interface DashboardOptionViewModel {
  Zones: DropdownItemModel[];
  Autobedrijven: AutobedrijfViewModel[];
  Perioden: DropdownItemModel[];
  Vestigingen: VestigingViewModel[];
  SoortenLead: DropdownItemModel[];
}

interface DashboardSettingsViewModel {
  CustomStartDate: string | null;
  CustomEndDate: string | null;
  SelectedPeriod: FixedPeriodType;
  SelectedZones: number[];
  SelectedAutobedrijven: string[];
  SelectedVestigingen: string[];
  SelectedLeadsoorten: number[];
  SelectedMerken: string[];
}

export interface FilterValues {
  period: FilterValuesPeriod | null;
  zonesValue: any[];
  autobedrijvenValue: any[];
  vestigingenValue: any[];
  soortenLeadValue: any[];
  merkenValue: any[];
  periodFromDate: Date;
  periodToDate: Date;
  customFromDate: Date;
  customToDate: Date;
}

export default Vue.extend({
  props: {
    selectedOptions: {
      required: true,
      type: Object as () => FilterValues,
      default: {
        period: {} as null | any,
        zonesValue: [] as any[],
        autobedrijvenValue: [] as any[],
        vestigingenValue: [] as any[],
        soortenLeadValue: [] as any[],
        merkenValue: [] as any[],
        periodFromDate: new Date(),
        periodToDate: new Date(),
        customFromDate: new Date(),
        customToDate: new Date(),
      } as FilterValues,
    },
  },

  data() {
    return {
      initialised: false,
      options: {
        Zones: [] as DropdownItemModel[],
        Autobedrijven: [] as AutobedrijfViewModel[],
        Perioden: [] as DropdownItemModel[],
        Vestigingen: [] as VestigingViewModel[],
        SoortenLead: [] as DropdownItemModel[],
      } as DashboardOptionViewModel,
      handlePreferenceChangedDebounced: null as null | Function,
      autobedrijvenOptionsUpdate: 0,
      vestigingenOptionsUpdate: 0,
    };
  },

  watch: {
    locale(newValue) {
      if (!!newValue) {
        this.updateLeadSoorten();
      }
    },
  },

  computed: {
    locale(): string | null {
      return this.$store.getters.locale;
    },

    zonesOptions(): null | any[] {
      return orderBy(get(this.options, "Zones", []), ["Omschrijving"], ["asc"]);
    },
    
    zoneGebruiker(): boolean {
      return this.$store.getters.zoneUser;
    },

    autobedrijvenOptions(): any[] {
      let update = this.autobedrijvenOptionsUpdate;
      let autobedrijven = get(
        this.options,
        "Autobedrijven",
        [] as AutobedrijfViewModel[]
      );
      let zones = this.selectedOptions.zonesValue;

      if (!isEmpty(zones) && !isEmpty(autobedrijven)) {
        autobedrijven = autobedrijven.filter((a) =>
          zones.some((zone: any) => String(zone.Id) === String(a.ZoneId))
        );
      }

      return orderBy(autobedrijven, ["Omschrijving"], ["asc"]);
    },

    vestigingenOptions(): any[] {
      let update = this.vestigingenOptionsUpdate;
      let vestigingen = get(
        this.options,
        "Vestigingen",
        [] as VestigingViewModel[]
      );

      if (!isEmpty(this.autobedrijvenOptions) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          (this.autobedrijvenOptions as any[]).some(
            (a: any) => String(a.Id) === v.AutobedrijfId
          )
        );
      }

      let selectedAutobedrijven = this.selectedOptions.autobedrijvenValue;

      if (!isEmpty(selectedAutobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          (selectedAutobedrijven as any[]).some(
            (a: any) => String(a.Id) === v.AutobedrijfId
          )
        );
      }

      return orderBy(vestigingen, ["Omschrijving"], ["asc"]);
    },

    soortenLeadOptions(): null | any[] {
      return get(this.options, "SoortenLead", []);
    },

    multipleMakes(): boolean {
      return this.$store.getters.multipleMakes();
    },

    makeOptions(): DropdownItemStringViewModel[] {
      if (this.multipleMakes) {
        return (this.$store.getters.importeurMerken as string[]).map((merk) => {
          return { Id: merk, Omschrijving: merk };
        });
      }
      return [];
    },
  },
  methods: {
    handleDateoptionsChanged(perioden: { Id: number; Omschrijving: string }[]) {
      this.options.Perioden = perioden;
    },

    onDateRangePickerMounted(perioden: { Id: number; Omschrijving: string }[]) {
      this.handleDateoptionsChanged(perioden);
      this.fillFilters();
    },

    fillFilters() {
      axios
        .get("/api/backend/v1/dashboard/leads/options")
        .then((response) => {
          if (!!response && !!response.data) {
            const {
              Zones,
              Autobedrijven,
              Vestigingen,
              SoortenLead,
            } = response.data;
            this.options.Zones = Zones;
            this.options.Autobedrijven = Autobedrijven;
            this.options.Vestigingen = Vestigingen;

            let onbekend = {
              Id: 0,
              Omschrijving: `${this.$i18n.t("unknown")}`,
            } as DropdownItemModel;
            this.options.SoortenLead = [onbekend, ...SoortenLead]; //concat(onbekend, SoortenLead);

            this.$emit("options-initialised", {
              Zones,
              Autobedrijven,
              Vestigingen,
              SoortenLead,
            });
            this.getSavesPreferences();
          }
        })
        .catch((error) => {});
    },

    getSavesPreferences() {
      axios
        .get("/api/backend/v1/identity/preferences/dashboard")
        .then((response) => {
          if (!!response && !!response.data && !!response.data.FilterSettings) {
            const filtersettings = response.data
              .FilterSettings as DashboardSettingsViewModel;

            this.selectedOptions.zonesValue = (get(
              this.options,
              "Zones",
              []
            ) as any[]).filter(
              (v) => filtersettings.SelectedZones.indexOf(v.Id) > -1
            );

            this.selectedOptions.merkenValue = this.makeOptions.filter(
              (v) =>
                (get(filtersettings, "SelectedMerken", []) as any[]).indexOf(
                  v.Id
                ) > -1
            );

            this.selectedOptions.autobedrijvenValue = (get(
              this.options,
              "Autobedrijven",
              []
            ) as any[]).filter(
              (m) => filtersettings.SelectedAutobedrijven.indexOf(m.Id) > -1
            );

            this.selectedOptions.vestigingenValue = (get(
              this.options,
              "Vestigingen",
              []
            ) as any[]).filter(
              (a) => filtersettings.SelectedVestigingen.indexOf(a.Id) > -1
            );

            this.selectedOptions.soortenLeadValue = (get(
              this.options,
              "SoortenLead",
              []
            ) as any[]).filter(
              (a) => filtersettings.SelectedLeadsoorten.indexOf(a.Id) > -1
            );

            let period = find(
              get(this.options, "Perioden", []),
              (p) => p.Id === filtersettings.SelectedPeriod
            );

            if (!!period) {
              this.selectedOptions.period = period;
            }

            this.selectedOptions.customFromDate = moment(
              filtersettings.CustomStartDate as string
            ).local().startOf("day").toDate();

            this.selectedOptions.customToDate = moment(
              filtersettings.CustomEndDate as string
            ).local().endOf("day").toDate();
          } //preferences set

          this.initialised = true;
          this.$emit("initialised", true);
        })
        .catch((error) => {});
    },

    reduceSelectedOptions(): void {
      let autobedrijven = get(
        this.options,
        "Autobedrijven",
        [] as AutobedrijfViewModel[]
      );
      let zones = this.selectedOptions.zonesValue;

      if (!isEmpty(zones) && !isEmpty(autobedrijven)) {
        autobedrijven = autobedrijven.filter((a) =>
          zones.some((zone: any) => String(zone.Id) === String(a.ZoneId))
        );
      }

      if (!isEmpty(zones)) {
        let previous = isEmpty(this.selectedOptions.autobedrijvenValue)
          ? 0
          : this.selectedOptions.autobedrijvenValue.length;

        // verwijder geselecteerde autobedrijven als die buiten het huidige zone filter vallen
        this.selectedOptions.autobedrijvenValue = this.selectedOptions.autobedrijvenValue.filter(
          (aValue: any) =>
            zones.some((zone: any) => String(zone.Id) === String(aValue.ZoneId))
        );
        let current = isEmpty(this.selectedOptions.autobedrijvenValue)
          ? 0
          : this.selectedOptions.autobedrijvenValue.length;

        if (current != previous) this.autobedrijvenOptionsUpdate++;
      }

      ////////////////////////////////////////////////////////////////////
      let vestigingen = get(
        this.options,
        "Vestigingen",
        [] as VestigingViewModel[]
      );

      if (!isEmpty(autobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          autobedrijven.some((a: any) => String(a.Id) === v.AutobedrijfId)
        );
      }

      let selectedAutobedrijven = this.selectedOptions.autobedrijvenValue;

      if (!isEmpty(selectedAutobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          (selectedAutobedrijven as any[]).some(
            (a: any) => String(a.Id) === v.AutobedrijfId
          )
        );
      }

      let previous = isEmpty(this.selectedOptions.vestigingenValue)
        ? 0
        : this.selectedOptions.vestigingenValue.length;

      // update selected vestigingen als die buiten het huidige filter vallen
      this.selectedOptions.vestigingenValue = this.selectedOptions.vestigingenValue.filter(
        (vValue: any) =>
          vestigingen.some((v: any) => String(v.Id) === String(vValue.Id))
      );

      let current = isEmpty(this.selectedOptions.vestigingenValue)
        ? 0
        : this.selectedOptions.vestigingenValue.length;

      if (current != previous) this.vestigingenOptionsUpdate++;
    },

    handlePreferencesChanged: function() {
      if (!this.handlePreferenceChangedDebounced) {
        this.handlePreferenceChangedDebounced = debounce(() => {
          this.reduceSelectedOptions();
          this.persistPreferences();
          this.$emit("preferences-changed", true);
        }, 300);
      }

      this.handlePreferenceChangedDebounced();
    },

    persistPreferences() {
      if (!this.initialised) return;

      let settings = {
		    CustomStartDate: (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString(),
        CustomEndDate: (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString(),
        SelectedPeriod: get(
          this.selectedOptions,
          "period.Id",
          FixedPeriodType.ThisYear
        ),
        SelectedZones: get(
          this.selectedOptions as Object,
          "zonesValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        SelectedAutobedrijven: get(
          this.selectedOptions as Object,
          "autobedrijvenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedVestigingen: get(
          this.selectedOptions as Object,
          "vestigingenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedMerken: get(
          this.selectedOptions as Object,
          "merkenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedLeadsoorten: get(
          this.selectedOptions as Object,
          "soortenLeadValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
      } as DashboardSettingsViewModel;

      axios.post("/api/backend/v1/identity/preferences/dashboard", settings, {
        headers: { "Content-Type": "application/json" },
      });
    },

    updateLeadSoorten() {
      this.options.SoortenLead.forEach(
        (soortLead: { Id: any; Omschrijving: string }) => {
          switch (soortLead.Id) {
            case 0:
              soortLead.Omschrijving = `${this.$i18n.t("unknown")}`;
              break;
          }
        }
      );
      this.selectedOptions.soortenLeadValue = this.options.SoortenLead.filter(
        (soortLead: any) =>
          this.selectedOptions.soortenLeadValue.some(
            (selected: any) => String(selected.Id) === String(soortLead.Id)
          )
      );
    },
  },
  components: {
    Multiselect,
    DateRangePicker,
  },
});
